import { useEffect } from 'react';
import { StepStage } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, expression, number, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { WizardMode } from '../wizard/wizard-constants.js';
import { useWizard } from '../wizard/wizard-context.js';
import { WizardStepContentContainer, WizardStepResultContainer } from './internal-wizard-step.js';
import WizardStepAPI from './wizard-step-api.js';
import './wizard-step.css';
const awesomeProps = {
    api: WizardStepAPI,
    containers: [WizardStepContentContainer, WizardStepResultContainer],
    type: ComponentType.FORM,
};
function WizardStep(props) {
    const { children, identifier } = props;
    const wizardContext = useWizard();
    useEffect(() => {
        wizardContext.addStep(props);
        return () => {
            wizardContext.removeStep(identifier);
        };
    }, [identifier, children]);
    return null;
}
WizardStep.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    collapsed: bool.notEnumerable(),
    done: bool.notEnumerable(),
    identifier: string,
    index: number.notEnumerable(),
    last: bool.notEnumerable(),
    mode: oneOf(enumValues(WizardMode)).notEnumerable(),
    readOnly: bool,
    result: oneOfType([element, arrayOf(element)]).notEnumerable(),
    stage: oneOf(enumValues(StepStage)).notEnumerable(),
    subtitle: expression,
    title: expression,
    uuid: string,
};
WizardStep.defaultProps = {
    collapsed: true,
    index: 0,
    readOnly: false,
};
AwesomeComponent(awesomeProps)(WizardStep);
export { WizardStep, };
//# sourceMappingURL=wizard-step.js.map